import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

const EJEMPLO = `codigo_depto,nombre,email,cuota_clp,rut,telefono
101,María González,maria@ejemplo.cl,85000,,
102,Pedro Rivadeneira,pedro@ejemplo.cl,85000,,`;

export default function ImportarPage() {
  const { cid } = useParams();
  const [csv, setCsv] = useState(EJEMPLO);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setResult(null);
    try {
      const { data } = await api.post(`/gastos-comunes/condominios/${cid}/import/catalogo`, { csv });
      setResult(data);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <>
      <div className="page-header">
        <h2>Importar catálogo</h2>
        <p>Carga masiva de propietarios (Hito 1 §13). Columnas: departamento, nombre, email, cuota.</p>
      </div>
      <div className="card">
        {error && <div className="alert alert-error">{error}</div>}
        {result && (
          <div className="alert alert-success">
            Importados: {result.creados} / {result.total}. Errores: {result.errores?.length || 0}.
          </div>
        )}
        {result?.errores?.length > 0 && (
          <pre className="link-box" style={{ maxHeight: 200, overflow: 'auto' }}>
            {result.errores.map((e) => `Línea ${e.linea}: ${e.error}\n`).join('')}
          </pre>
        )}
        <form onSubmit={submit}>
          <div className="field">
            <label>CSV (UTF-8)</label>
            <textarea
              value={csv}
              onChange={(e) => setCsv(e.target.value)}
              rows={12}
              style={{ width: '100%', fontFamily: 'ui-monospace, monospace', fontSize: '0.85rem' }}
            />
          </div>
          <button type="submit" className="btn">
            Validar e importar
          </button>
        </form>
      </div>
    </>
  );
}
